import {fabric} from "fabric";

export const modesMix={
}
